// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"821d39d5","453":"8c6b12bc"}[chunkId] + ".chunk.js";
};